import { useCloudComputingPower } from 'store/src/stores/use-cloud-computing-power'
import { lodashDeepClone, merge } from 'utils'
import ico from '../../assets/image/hashspace/favicon.ico'
import logo from '../../assets/image/hashspace/logo.png'
import bannerRight from '../../assets/image/top-credit/home/banner-right.png'
import downloadBg from '../../assets/image/top-credit/home/support-platform/download-bg.png'
import { BaseConfig, type BaseConfigSource } from '../common-config'

const primary = '#3C53FF'
const lightPrimary = '#3C53FF'
const secondaryPrimary = '#3C53FF'
const tertiaryPrimary = '#3C53FF'

export const HashSpaceLightConfig = merge<BaseConfigSource, PlatformConfig>(lodashDeepClone(BaseConfig), {
  themeType: 'light',
  logo: logo,
  footerLogo: logo,
  platformName: 'Hashspace',
  contentWidth: `1200px`,
  loginShowDownload: false,
  colors: {
    lightPrimary: lightPrimary,
    hoverPrimary: primary,
    // 根据最新的UI提供的色值库的颜色
    primary,
    secondaryPrimary,
    tertiaryPrimary,
    link: '#4B5BE7',
    text: {
      base: '#202630',
      reverse: '#fff',
      primaryAlt: '#202630',
      secondary: '#989BA2',
      tertiary: '#A0A3A7',
    },
    cardBorder: '#d1d7e1',
    divider: '#ebeef5',
    borderSelected: '#74777B',
    sliderMenu: '#F4F5F6',
    tip: '#F6F7F9',
    bg: {
      base: '#FFFFFF',
      icon: {
        primary: '#151519',
        quaternary: '#75777A',
        secondary: '#75777A',
        trigger: '#E3E3E3',
      },
      button: {
        base: primary,
        primary: primary,
        primaryTextColor: '#fff',
        aux: '#F6F7F9',
        disabled: '#C2C7D0',
      },
      tag: {
        base: '#F3F4F6',
      },
      form: {
        base: '#F7F7F9',
        input: '#F7F7F9',
        modal: '#F1F3F6',
        card: '#ffffff',
      },
      mainPage: {
        base: '#FFFFFF',
        card: '#F5F5F7',
      },
      modal: {
        base: '#FFFFFF',
        card: '#ffffff',
        shadow: 'rgba(224, 227, 237, 0.9)',
      },
    },
    loginBg: 'linear-gradient(243deg, #E8F3FF 0%, #FEFEFE 28.7%)',
  },
  ico,
  header: {
    boxShadow: '0 1px 10px rgba(0, 0, 0, 0.11)',
    color: '#202630',
    background: '#FFFFFF',
    aColor: '#202630',
    regBtnBgColor: '#3C53FF',
    regTextColor: '#fff', // 注册按钮文字颜色
    downloadTextColor: '#202630',
    activeColor: '#3C53FF',
  },

  home: {
    banner: {
      bannerRight: bannerRight,
    },
    supportPlatform: {
      downloadBg: downloadBg,
    },
  },

  helpCenter: {
    serviceAgreement: '/service-agreement',
    privacyAgreement: '/privacy-policy',
  },
  loadExternalConfig() {
    return useCloudComputingPower().loadExternalConfig()
  },
  cloud: {
    colors: {
      bg: {
        card: {
          fontColor: '#fff',
        },
      },
    },
  },
} as BaseConfigSource as PlatformConfig)
